function CategoryFilter() {
    this.node = null;
    this.id = null;
    this.filter_id = "category-filter";
    this.parent_node = ".mogo-ui-category-filter";
    this.filter_node = "ul#" + this.filter_id;
    this.category_node = this.parent_node + " ul:last-of-type";
    this.initAllReady = function() { };
    this.toggleCategories = function(){
        if( $(this.category_node).is(":visible") )
            $(this.category_node).slideUp();
        else
            $(this.category_node).slideDown();
    };
    this.init = function(){
        var category = "All Categories";
        var url_path = window.location.pathname;
        if( url_path.match(/tag/) !== null ){
            var tag_index;
            url_path = url_path.slice(1,url_path.length-1).split("/");
            tag_index = url_path.indexOf("tag") + 1;
            category = url_path[tag_index];
        }
        $(this.node).prepend('<ul id="'+this.filter_id+'"><li><a class="button no-icon icon-arrowdown" href="#"><span class="link-text no-icon">'+category+'</span></a></li></ul>');
        $(this.filter_node).on('click',  $.proxy(this.toggleCategories,this));
    };
    
};